const deepClonePoint = (point) => {
    const clonedPoint = { ...point };

    if (point.m) {
        clonedPoint.m = { ...point.m };
    }

    if (point.a) {
        clonedPoint.a = { ...point.a };
    }

    return clonedPoint;
};

export const deepClonePoints = (points) => {
    const clonedPoints = new Array(points.length);

    for (let i = 0, len = points.length; i < len; i++) {
        clonedPoints[i] = deepClonePoint(points[i]);
    }

    return clonedPoints;
};
